const categories = [
  { value: "English (en)", label: "en" },
  { value: "Hindi (hi)", label: "hi" },
  { value: "Spanish (es)", label: "es" },
  { value: "French (fr)", label: "fr" },
  { value: "Japanese (ja)", label: "ja" },
  { value: "Russian (ru)", label: "ru" },
  { value: "German (de)", label: "de" },
  { value: "Italian (it)", label: "it" },
  { value: "Korean (ko)", label: "ko" },
  { value: "Brazilian Portuguese (pt-BR)", label: "pt-BR" },
  { value: "Arabic (ar)", label: "ar" },
  { value: "Turkish (tr)", label: "tr" }
];

export default categories;
